// extracted by css-extract-rspack-plugin
export default {"switcher":"switcher-_IGPlU","icon":"icon-V1J580"};